import Image, { StaticImageData } from 'next/image'
import styles from './InfiniteCarousel.module.scss'

interface IProps {
  images: StaticImageData[]
}

const InfiniteCarousel = ({ images }: IProps) => (
  <div className={styles['infinite-carousel']}>
    <div className={styles['infinite-carousel__slide']}>
      {images.map((image, index) => (
        <Image
          src={image}
          alt='Company logo'
          className={styles['inifite-carousel__img']}
          loading='lazy'
        />
      ))}
    </div>
    <div className={styles['infinite-carousel__slide']}>
      {images.map((image, index) => (
        <Image
          src={image}
          alt='Company logo'
          className={styles['inifite-carousel__img']}
          loading='lazy'
        />
      ))}
    </div>
  </div>
)

export default InfiniteCarousel
